export default {
  en: {
    // English text from TDS Community `Tabs`
    previousLabel: 'Move menu to the left',
    nextLabel: 'Move menu to the right'
  },
  fr: {
    previousLabel: 'Déplacer le menu vers la gauche',
    nextLabel: 'Déplacer le menu vers la droite'
  }
};